import { FilterResults, PostFilterBody, screener } from '@api';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

import { hasEmptyEntityTagValues } from './utils';

export const isApiEntityScreenerV5EntitiesEnabled = () =>
  useFlags
    .getState()
    .getFeatureFlagState('DATA-1432-api_entity_screener_v5_entities');

export const isApiEntityScreenerV5SchemasEnabled = () =>
  useFlags
    .getState()
    .getFeatureFlagState('DATA-1432-api_entity-screener_v5_schemas');

export const getPostFilterEntitiesPath = () =>
  isApiEntityScreenerV5EntitiesEnabled()
    ? screener.postFilterV5.path
    : screener.postFilter.path;

export const getScreenerFiltersPath = (uiComponent?: string) =>
  isApiEntityScreenerV5SchemasEnabled()
    ? screener.getFiltersV5.path(uiComponent)
    : screener.getFilters.path(uiComponent);

export const fetchFilteredEntitiesTagsOnly = (
  filters: PostFilterBody,
  signal?: AbortSignal
) =>
  wretchRequest<FilterResults>(getPostFilterEntitiesPath(), {
    method: 'post',
    body: {
      filters,
      tags_only: true,
    },
    signal,
  });

export const fetchFilteredEntities = (
  filters: PostFilterBody,
  signal?: AbortSignal
) => {
  if (hasEmptyEntityTagValues(filters)) {
    return Promise.resolve({
      entities: [],
      data: [],
      page: {
        current: 0,
        size: 0,
        next: undefined,
      },
      total_count: 0,
    });
  }

  return wretchRequest<FilterResults>(getPostFilterEntitiesPath(), {
    method: 'post',
    body: {
      filters,
      tags_only: false,
    },
    signal,
  });
};
